package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.BoxSizing.BORDER_BOX
import com.downdogapp.JustifyContent.FLEX_END
import com.downdogapp.Overflow.HIDDEN
import com.downdogapp.Position.RELATIVE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.TextOverflow.ELLIPSIS
import com.downdogapp.WhiteSpace.NOWRAP
import com.downdogapp.client.*
import com.downdogapp.client.controllers.start.StatsPage
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.start.HistoryPageView.Companion.defaultPadding
import com.downdogapp.client.widget.*
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLSpanElement

actual class StatsPageView actual constructor() : AbstractView(), View {

  private var table: TableView
  private var title: HTMLSpanElement
  private var allAppTypesToggle: TogglePill

  override val root = createDiv {
    position = RELATIVE
    this@StatsPageView.title = startPageTitle()

    startPageContent {
      horizontalFlexBox(horizontalJustify = FLEX_END) {
        defaultPadding()
        allAppTypesToggle = togglePill(
          lazyLeftText = { Strings.ALL },
          lazyRightText = { App.appType.shortDisplayName },
          getValue = { !StatsPage.displayAllAppTypes },
          onValueChanged = { StatsPage.displayAllAppTypes = !it }
        )
      }
      table = tableView(::getContents)
    }
  }

  actual fun refreshView() {
    title.text = StatsPage.title
    table.refreshContents()
    allAppTypesToggle.refresh()
  }

  actual fun refreshCalendar() {
    refreshView()
  }

  private fun getContents() = TableContents(
    rows = listOf(
      CustomRow.customRow(null) {
        root.apply {
          defaultPadding()
          horizontalFlexBox {
            infoBox(
              topText = StatsPage.weeklyGoalDescription,
              mainText = StatsPage.weeklyGoalDisplayString,
              clickFn = StatsPage::weeklyGoalSelectorClicked
            ) {
              marginRight = px(6)
            }
            infoBox(
              topText = StatsPage.statDescription,
              mainText = StatsPage.statDiplayString,
              clickFn = StatsPage::statTypeSelectorClicked
            ) {
              marginLeft = px(6)
            }
          }
        }
      },
      CustomRow.customRow(null) {
        root.apply {
          defaultPadding()
          calendar(
            selectWeekStart = StatsPage::calendarSelectWeekStart,
            decrementMonth = StatsPage::decrementMonth,
            incrementMonth = StatsPage::incrementMonth,
            getActiveYearMonth = { StatsPage.activeYearMonth }
          )
        }
      }
    )
  )

  companion object {

    private fun HTMLElement.infoBox(topText: String,
                                    mainText: String,
                                    clickFn: () -> Unit,
                                    block: HTMLDivElement.() -> Unit = {}) =
      verticalFlexBox {
        borderRadius = px(10)
        bgColor = Color.grey(0.15)
        padding = HORIZONTAL_CONTENT_GUTTER_PX
        width = percent(50)
        boxSizing = BORDER_BOX

        onClick { clickFn() }

        horizontalFlexBox {
          label(text = topText, fontSize = 16, fontWeight = FontWeight.SEMIBOLD) {
            whiteSpace = NOWRAP
            overflowX = HIDDEN
            textOverflow = ELLIPSIS
          }
          imageView(Images.GOAL_ARROW) {
            marginLeft = px(StatsPageViewConstants.GOAL_ARROW_LEFT_MARGIN)
            marginTop = px(4)
          }
        }

        label(text = mainText, fontSize = 28, fontWeight = FontWeight.MEDIUM) {
          marginTop = px(10)
          whiteSpace = NOWRAP
          overflowX = HIDDEN
          textOverflow = ELLIPSIS
        }

        block()
      }
  }
}
